import React from 'react';
// Data
import {
  CompanyEmailAddress,
} from '../../utils/Constants';
// Data
import { contactPinsArray } from '../../utils/data/CompanyData';
// Components
import SocialBigPins from '../socialMedia/SocialBigPins';

function ContactPageMainContainer() {
  return (
    <main role='main' className='grid gap-12 lg:gap-24 pt-12 mb-20'>
      {/* Contact Info */}
      <section className='grid gap-y-4 text-center text-xl px-8'>
        <div>
          <a
            href={`mailto:${CompanyEmailAddress}`}
            className='block break-words whitespace-normal overflow-hidden'
          >
            Email Now: <br /> <span className='text-sm lg:text-base'>{CompanyEmailAddress}</span>
          </a>
        </div>
      </section>

      {/* Social */}
      <div className='lg:grid lg:grid-flow-col lg:gap-x-8 lg:w-fit lg:mx-auto'>
        <SocialBigPins />

        <div className='py-6 grid md:grid-flow-col w-fit mx-auto gap-8'>
          {contactPinsArray.map((site, index) => (
            <a
              key={index}
              href={site.url}
              target='_blank'
              rel='noopener noreferrer'
              className='px-6 rounded-lg transition-transform transform hover:scale-105'
            >
              {site.logo && !site.icon ? (
                <img
                  src={site.logo}
                  alt={`${site.name} Logo`}
                  className='h-20 brightness-125 mx-auto'
                  loading='lazy'
                />
              ) : site.icon && site.logo ? (
                <div className='flex items-center justify-center gap-3'>
                  {/* Check if site.icon is a string or a React icon */}
                  {typeof site.icon === 'string' ? (
                    <img
                      src={site.icon}
                      alt={`${site.name} Icon`}
                      className='h-10'
                      loading='lazy'
                    />
                  ) : (
                    <span className='text-4xl text-colour7'>{site.icon}</span>
                  )}
                  <img
                    src={site.logo}
                    alt={`${site.name} Logo`}
                    className='h-16 brightness-125'
                    loading='lazy'
                  />
                </div>
              ) : site.icon && site.textOnly ? (
                // Special case: Telegram (Icon + Text)
                <div className='grid w-fit gap-4 justify-center mx-auto grid-flow-col items-center'>
                  <div>
                    {/* Check if site.icon is a string or a React icon */}
                    {typeof site.icon === 'string' ? (
                      <img
                        src={site.icon}
                        alt={`${site.name} Icon`}
                        className='h-10'
                        loading='lazy'
                      />
                    ) : (
                      <span className='text-4xl text-colour7'>{site.icon}</span>
                    )}
                  </div>
                  <div>
                    <span className='text-2xl lg:text-4xl uppercase text-center mt-2 text-colour1 font-semibold'>
                      {site.name}
                    </span>
                  </div>
                </div>
              ) : site.icon ? (
                <div className='grid justify-center h-fit'>
                  {/* Check if site.icon is a string or a React icon */}
                  {typeof site.icon === 'string' ? (
                    <img
                      src={site.icon}
                      alt={`${site.name} Icon`}
                      className='h-10'
                      loading='lazy'
                    />
                  ) : (
                    <span className='text-4xl text-colour7'>{site.icon}</span>
                  )}
                </div>
              ) : (
                <div className='text-center text-colour1 uppercase text-4xl font-bold'>
                  {site.name}
                </div>
              )}
              <div className='text-center'>
                <p className='text-2xl font-newsweekly'>{site.name}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </main>
  );
}

export default ContactPageMainContainer;
